import { useNavigate } from 'react-router'
import { useTheme } from '@mui/material'

import FullScreenDrawer from '../../../components/full-screen-drawer'
import useIsMobile from '../../../utils/hooks/useIsMobile'
import useStyles from '../index.styles'

import Order from './order'

const OrderDetails = () => {
  const classes = useStyles
  const navigate = useNavigate()
  const theme = useTheme()
  const isMobile = useIsMobile()

  if (isMobile)
    return (
      <FullScreenDrawer
        open={true}
        title="Order details"
        showCloseIcon={false}
        showBackIcon={true}
        onClose={() => navigate(-1)}
        modalPaperStyle={classes.orderDetailsDrawerPaper(theme)}
        contentContainerSx={{ paddingTop: 0 }}
      >
        <Order />
      </FullScreenDrawer>
    )
  return <Order />
}

export default OrderDetails
